import React, { useState, useEffect } from "react";
import "./Tiles.css";

const SwipeGesture = () => {
    const [showComponent, setShowComponent] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => {
        setShowComponent(false);
      }, 6000);
      return () => clearTimeout(timer);
    }, []);
  
    const handleTransitionEnd = () => {
      setShowComponent(false);
    };
    return (
      <img
        src='https://thegoodguys.sirv.com/dm/homepage-white-tiles/Assets/gesture_swipe%20(white)_3x.png'
        className={`whiteTiles-gesture__mobile text-size-150 pos-absolute visible-xs ${showComponent ? 'fade-in' : 'fade-out'}`}
        onTransitionEnd={handleTransitionEnd}
      />
    );
  }

  export default SwipeGesture;